import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import moment from 'moment/moment';

import { FilterInterface } from '../../../shared/filter-bar/filter-bar.component';
import { DashboardType, GetConversionsGQL } from '../../../../generated/graphql';
import { StandupDashboardServiceService } from '../standup-dashboard-service.service';
import { RelayIdService } from '../../../shared/relay-id.service';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-conversions-table',
  templateUrl: './conversions-table.component.html',
  styleUrls: ['./conversions-table.component.scss']
})
export class ConversionsTableComponent implements OnInit {
  CONVERSION_KEY_MAP = {
    initial_to_interested: 'CONVERSIONS.INITIAL_TO_INTERESTED',
    interested_to_interview: 'CONVERSIONS.INTERESTED_TO_INTERVIEW',
    interview_to_presented: 'CONVERSIONS.INTERVIEW_TO_PRESENTED',
    presented_to_client_interview: 'CONVERSIONS.PRESENTED_TO_CLIENT_INTERVIEW',
    client_interview_to_health_check: 'CONVERSIONS.CLIENT_INTERVIEW_TO_HEALTH_CHECK',
    health_check_to_employed: 'CONVERSIONS.HEALTH_CHECK_TO_EMPLOYED'
  };

  // filterCache: FilterInterface;
  // initDates: FilterInterface;
  isDatePickerClosed = false;
  regionLookup = {};
  isLoading = true;
  regionDisplayedColumns = [];
  orderDisplayedColumns = [];
  rawData = [];
  regionDataSource = [];
  orderDataSource = [];
  dateFilter = new FormControl();

  @Input() dashboardTitle;
  @Input() cardDescription: string;
  @Input() card;
  @Input() dashboardItem: DashboardType;

  constructor(
    private dashboardService: StandupDashboardServiceService,
    private getConversionsGQL: GetConversionsGQL,
    private relayIdService: RelayIdService,
    private dialog: MatDialog
  ) { }

  openDescription(template: TemplateRef<any>) {
    this.dialog.open(template, { autoFocus: false, maxHeight: '80dvh' });
  }

  formatInnerText(text: string): string {
    return text.replace(/\n/g, '<br>');
  }

  ngOnInit(): void {
    // this.initDates = {
    //   dateRange: {
    //     dateFrom: moment().startOf('isoWeek'),
    //     dateTo: moment().endOf('isoWeek')
    //   }
    // };
    this.dateFilter.valueChanges.subscribe(value => {
      if (value) {
        this.loadConversions(
          moment(value).startOf('day').format('YYYY-MM-DD'),
          moment(value).endOf('day').format('YYYY-MM-DD')
        );
      }
    });
    this.dateFilter.setValue(moment());
  }

  // onFilterChanges(filters: FilterInterface): void {
  //   const dateRange = filters.dateRange;
  //   const cachedRange = this.filterCache?.dateRange;
  //
  //   this.isDatePickerClosed = !!(
  //     !this.filterCache || (dateRange.dateFrom.isSame(cachedRange.dateFrom) && (!cachedRange.dateTo && dateRange.dateTo))
  //   );
  //
  //   this.filterCache = filters;
  //
  //   if ((this.isDatePickerClosed) && dateRange && (dateRange.dateFrom && dateRange.dateTo)) {
  //     this.loadConversions(
  //       dateRange.dateFrom ? moment(dateRange.dateFrom).format('YYYY-MM-DD') : null,
  //       dateRange.dateTo ? moment(dateRange.dateTo).format('YYYY-MM-DD') : null
  //     );
  //   }
  // }

  private loadConversions(dateFrom: string, dateTo: string): void {
    if (!this.card?.id) {
      return;
    }

    this.rawData = [];
    this.regionLookup = {};
    this.regionDataSource = [];
    this.regionDisplayedColumns = [];
    this.orderDataSource = [];
    this.orderDisplayedColumns = [];

    this.isLoading = true;

    const regionId = this.dashboardItem?.regionGroup?.id || undefined;
    this.getConversionsGQL.fetch({id: this.card.id, dateTo, dateFrom, dashboardRegion: regionId}).subscribe((metricGroups) => {
      this.rawData = metricGroups.data.metricGroupsAssignment.edges.map((group) => ({
        id: group.node.metricGroup.id,
        title: group.node.metricGroup.title,
        metricValues: group.node.metricGroup.metricvalueSet.edges.map((edge) => ({
          id: edge.node.id,
          key: edge.node.key,
          value: edge.node.value,
          order: edge.node.order,
          region: edge.node.regionGroup.title
        }))
      }));
      this.transformMetricGroups(this.rawData);
      this.isLoading = false;
    }, e => this.isLoading = false);
  }

  transformMetricGroups(data) {
    const regionBlock = data.find(x => x.title === 'Region conversions');
    const orderBlock = data.find(x => x.title === 'Order conversions');

    if (regionBlock?.metricValues?.length) {

      const regionName = regionBlock.metricValues[0].region;

      const regionRow: any = { region: regionName };

      regionBlock.metricValues.forEach(v => {
        regionRow[v.key] = v.value;

        this.regionLookup[v.key] = v.value;
      });

      this.regionDataSource = [regionRow];

      const dynamicKeys = regionBlock.metricValues.map(v => v.key);
      this.regionDisplayedColumns = ['region', ...dynamicKeys];
    }

    if (orderBlock?.metricValues?.length) {

      const byOrder = {};

      orderBlock.metricValues.forEach(v => {
        const orderId = this.relayIdService.parseId(v?.order?.id);

        const orderName =
          v.order?.specification?.positionTitle
            ? `${v.order.specification.positionTitle} - ${orderId}`
            : orderId;

        if (orderName) {
          if (!byOrder[orderName]) {
            byOrder[orderName] = { orderName };
          }

          const regionValue = this.regionLookup[v.key];

          byOrder[orderName][v.key] = {
            value: v.value ?? 0,
            isLower:
              typeof regionValue === 'number' &&
              typeof v.value === 'number' &&
              v.value < regionValue
          };
        }
      });

      this.orderDataSource = Object.values(byOrder);

      const dynamicKeys = [...new Set(orderBlock.metricValues.filter(v => v.order).map(v => v.key))];
      this.orderDisplayedColumns = ['orderName', ...dynamicKeys];
    }
  }

  toPercent(value: number): string {
    if (typeof value === 'string') {
      return value;
    }
    if (value === null || value === undefined) {
      return '-';
    }
    return Math.round(value * 100) + '%';
  }
}
